module.exports = __webpack_public_path__ + "static/media/HeroImgMobile.a240aa20.svg";